import axios from 'axios';
import { ElMessage } from 'element-plus';
// 创建 axios 实例
const request = axios.create({
    baseURL: '/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});
// 请求拦截器 - 自动添加认证头
request.interceptors.request.use((config) => {
    console.log('发起请求:', {
        method: config.method,
        url: config.url,
        baseURL: config.baseURL,
        fullURL: `${config.baseURL}${config.url}`
    });
    // 从 localStorage 获取 token
    const token = localStorage.getItem('nps_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('添加Authorization头');
    }
    else {
        console.log('未找到token');
    }
    return config;
}, (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
});
// 响应拦截器
request.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    console.error('API Error:', error);
    // 处理认证错误
    if (error.response?.status === 401) {
        // Token 过期或无效，清除本地存储并跳转到登录页
        localStorage.removeItem('nps_token');
        localStorage.removeItem('nps_user_info');
        // 如果不是登录页面，则跳转到登录页
        if (window.location.pathname !== '/login') {
            ElMessage.error('登录已过期，请重新登录');
            window.location.href = '/login';
        }
    }
    else if (error.response?.status === 403) {
        ElMessage.error('权限不足');
    }
    else if (error.response?.status >= 500) {
        ElMessage.error('服务器错误，请稍后重试');
    }
    return Promise.reject(error);
});
export default request;
